export default __webpack_public_path__ + "static/media/ic_card_white.b2e2b3a9.svg";